<template>
  <vs-popup :active.sync="open"
            :buttons-hidden="true"
            @close="onClickClose()"
            class="assign-formulation-stock-inventory-pop-up"
            title="UPDATE SUNDRY STOCK INVENTORY">
    <vx-card no-shadow >
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="update-rm-stock-popup" @submit.prevent="handleSubmit(onClickAssign)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="code" name="code" rules="" v-slot="{ errors }">
                <small class="label">Batch Number</small>
                <vs-input readonly v-model="form.code"   name="batch_no" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="sundry_item_code" name="sundry_item_code" rules="" v-slot="{ errors }">
                <small class="label">Sundry Item Code</small>
                <vs-input readonly :value="form.sundry_item_code"   name="sundry_item_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <!-- <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="batch_no" name="batch_no" rules="required" v-slot="{ errors }">
                <small class="label">Batch Number</small>
                <vs-input readonly v-model="form.batch_no"   name="batch_no" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div> -->

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="supplier_batch_no" name="supplier_batch_no" rules="" v-slot="{ errors }">
                <small class="label">Supplier Batch Number</small>
                <vs-input v-model="form.supplier_batch_no"   name="supplier_batch_no" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="total_quantity" name="total_quantity" rules="required|number" v-slot="{ errors }">
                <small class="label">Original Order Item Quantity</small>
                <vs-input disabled v-model="form.total_quantity"   name="company_product_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="available_quantity" name="available_quantity" rules="required|integer" v-slot="{ errors }">
                <small class="label">Available Quantity</small>
                <vs-input v-model="form.available_quantity" name="available_quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>
          <vs-alert v-if="diff_qty !== 0" active="true" class="w-full h-auto" color="warning" icon-pack="feather" icon="icon-info">
            You are reducing/increasing stock level by {{ diff_qty }}
          </vs-alert>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="location" name="location" rules="required" v-slot="{ errors }">
                <small class="label">Location</small>
                <vs-input v-model="form.location"   name="location" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="reason_for_change" name="reason_for_change" rules="required" v-slot="{ errors }">
                <small class="label">Reason for change</small>
                <v-select  :clearable="true" name="reason" placeholder="" v-model="form.reason_for_change" :options="reasons" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <small class="text-danger">{{errors[0]}}</small>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="form.reason_for_change === 'Other'">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="other_reason" name="other_reason" rules="required" v-slot="{ errors }">
                <small class="label">Other reason</small>
                <vs-input v-model="other_reason" name="available_quantity" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <vs-alert v-if="diff_qty !== 0 && !['Assigned to NPD', 'Sample to QC'].includes(form.reason_for_change)" active="true" class="w-full h-auto" color="danger" icon-pack="feather" icon="icon-info">
            The adjusted stock {{ diff_qty }} will be added to waste management for disposal
          </vs-alert>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="onClickClose()" class="ml-4 mt-2" type="border" color="warning">Close</vs-button>
          </div>

        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'

  const ManufacturingRepository = RepositoryFactory.get('manufacturing');
  const SettingsRepository = RepositoryFactory.get('settings');
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  function initialState() {
    return {
      open: false,
      id: '',
      reasons: ['Assigned to NPD', 'Product Loss - Human error', 'Product Loss - Multiple weight out', 'Sample to QC', 'Added warehouse location','Product Expired/Waste Managed', 'Inventory Difference', 'Other'],
      form: {
        batch_no: '',
      },
      other_reason: '',
      available_qty: ''
    }
  }

  export default {
    name: 'UpdateSundryStockPopUp',
    data() {
      return initialState()
    },
    methods: {
      async openPopup(id) {
        try {
          await Object.assign(this.$data, initialState());
          this.$refs.form.reset();
          this.id = id;
          this.open = true;
          await this.fetchRmStockDetails()
        } catch (error) {

        }
      },
      async onClickAssign() {
        const vue = this
        await this.$vs.loading({
          container: '#update-rm-stock-popup',
          scale: 0.45
        })
        try {
          const payload = {
            total_quantity: this.form.total_quantity,
            location: this.form.location,
            available_quantity: this.form.available_quantity,
            reason_for_change: this.form.reason_for_change !== 'Other' ? this.form.reason_for_change : this.other_reason ,
            supplier_batch_no: this.form.supplier_batch_no
          }
          await ManufacturingRepository.updateSundryItemInventory(this.id, payload)
          this.showSuccessMessage('Sundry Stock Inventory Updated!')
          this.open = false;
          this.$emit('refreshData')
          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
        } catch (e) {
          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
          this.convertAndNotifyError(e)
        }
      },
      async fetchRmStockDetails() {
        await this.$vs.loading({
          container: '#update-rm-stock-popup',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getSundryItemInventory(this.id)
          this.form = data.data
          this.available_qty = this.form.available_quantity

          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
        } catch (e) {
          this.$vs.loading.close('#update-rm-stock-popup > .con-vs-loading')
          this.showErrorMessage(e.response.data.data.errors)
        }
      },
      onClickClose() {
        this.$emit('refreshData')
        this.open = false
      }
    },
    components: {
      'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
    computed: {
      diff_qty: function () {
        let diff = Number(this.form.available_quantity) - Number(this.available_qty)
        return Math.abs(diff)
      }
    }
  }
</script>

<style scoped>
  .assign-formulation-stock-inventory-pop-up >>> .vs-popup {
    min-height: 60% !important;
    min-width: 40% !important;
  }

</style>
